import http from "@/libs/api.request";
function getPrintTemplate(code, reqParams) {
  return http.request({
    url: `/printTemplate/data/${code}`,
    method: "post",
    type: "json",
    data: reqParams
  }).then(async (res) => {
    return res;
  });
}
function getPrinterList() {
  if (window.hiprint && window.hiprint.hiwebSocket) {
    return window.hiprint.hiwebSocket.getPrinterList() || [];
  }
  return [];
}
function refreshPrinterList() {
  if (window.hiprint && window.hiprint.hiwebSocket) {
    window.hiprint.hiwebSocket.refreshPrinterList();
  }
}
function isClientConnected() {
  if (window.hiprint && window.hiprint.hiwebSocket) {
    return window.hiprint.hiwebSocket.opened || false;
  }
  return false;
}
export {
  getPrintTemplate,
  getPrinterList,
  isClientConnected,
  refreshPrinterList
};
